var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTranscription = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 0.903,
  d: "M6.44 3.438a1.675 1.675 0 1 1-3.35 0 1.675 1.675 0 0 1 3.35 0ZM4.765 6.548c-1.425 0-2.548.744-3.142 1.849-.4.745.284 1.501 1.13 1.501h4.025c.846 0 1.53-.756 1.13-1.501-.594-1.105-1.717-1.849-3.143-1.849Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.903,
  d: "M9.4 3.01a3.01 3.01 0 0 1 0 4.255M7.983 4.428a1.003 1.003 0 0 1 0 1.419"
})));
export default SvgTranscription;